/** @jsxImportSource @emotion/react */
import { createStyles } from '@quickbit/qb-design-system';

interface Props {
  merchantName?: string;
  logoUrl: string;
}

export const MerchantLogo = ({ merchantName, logoUrl }: Props) => {
  const styles = useStyles();
  return (
    <div css={styles.logoSectionContainer}>
      <img
        src={logoUrl}
        alt={`${merchantName} logo`}
        css={styles.merchantLogoImg}
      />
    </div>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  logoSectionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: spacing.m,
  },
  merchantLogoImg: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
  },
}));
